/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BillingContact } from './';
import {
    BillingContactFromJSON,
    BillingContactFromJSONTyped,
    BillingContactToJSON,
} from './';
import type { InvoicingSettings } from './';
import {
    InvoicingSettingsFromJSON,
    InvoicingSettingsFromJSONTyped,
    InvoicingSettingsToJSON,
} from './';
import type { LegalInformation } from './';
import {
    LegalInformationFromJSON,
    LegalInformationFromJSONTyped,
    LegalInformationToJSON,
} from './';
import type { PaymentSettings } from './';
import {
    PaymentSettingsFromJSON,
    PaymentSettingsFromJSONTyped,
    PaymentSettingsToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalEntityRequest
 */
export interface LegalEntityRequest {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityRequest
     */
    legalEntityId: string;
    /**
     * 
     * @type {LegalInformation}
     * @memberof LegalEntityRequest
     */
    legalInformation: LegalInformation;
    /**
     * 
     * @type {BillingContact}
     * @memberof LegalEntityRequest
     */
    billingContact: BillingContact;
    /**
     * 
     * @type {PaymentSettings}
     * @memberof LegalEntityRequest
     */
    paymentSettings: PaymentSettings;
    /**
     * 
     * @type {InvoicingSettings}
     * @memberof LegalEntityRequest
     */
    invoicingSettings: InvoicingSettings;
    /**
     * 
     * @type {Set<string>}
     * @memberof LegalEntityRequest
     */
    clientTeams: Set<string>;
}

/**
 * Check if a given object implements the LegalEntityRequest interface.
 */
export function instanceOfLegalEntityRequest(value: object): value is LegalEntityRequest {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('legalInformation' in value) || value['legalInformation'] === undefined) return false;
    if (!('billingContact' in value) || value['billingContact'] === undefined) return false;
    if (!('paymentSettings' in value) || value['paymentSettings'] === undefined) return false;
    if (!('invoicingSettings' in value) || value['invoicingSettings'] === undefined) return false;
    if (!('clientTeams' in value) || value['clientTeams'] === undefined) return false;
    return true;
}

export function LegalEntityRequestFromJSON(json: any): LegalEntityRequest {
    return LegalEntityRequestFromJSONTyped(json, false);
}

export function LegalEntityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'legalInformation': LegalInformationFromJSON(json['legalInformation']),
        'billingContact': BillingContactFromJSON(json['billingContact']),
        'paymentSettings': PaymentSettingsFromJSON(json['paymentSettings']),
        'invoicingSettings': InvoicingSettingsFromJSON(json['invoicingSettings']),
        'clientTeams': json['clientTeams'],
    };
}

export function LegalEntityRequestToJSON(value?: LegalEntityRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntityId': value['legalEntityId'],
        'legalInformation': LegalInformationToJSON(value['legalInformation']),
        'billingContact': BillingContactToJSON(value['billingContact']),
        'paymentSettings': PaymentSettingsToJSON(value['paymentSettings']),
        'invoicingSettings': InvoicingSettingsToJSON(value['invoicingSettings']),
        'clientTeams': Array.from(value['clientTeams'] as Set<any>),
    };
}

